import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { routeNames } from '../../../assets/val/route-constants';
import { CustomerJourneyService } from '../../service/customer-journey/customer-journey.service';
import { LoggingService } from 'src/app/service/logging-service/logging.service';
import {
  Employment,
  KalpStatus,
  LeqInfoDto,
  LeqService,
} from '@app/service/leq/leq.service';
import { LeqType } from '@app/model/payment-request/payment-request.dto';
import { QueryParamsService } from '@app/service/query-params/query-params.service';
import { Store } from '@ngxs/store';

@Component({
  selector: 'app-loan-eligibility-questionnaire-summary',
  templateUrl: './loan-eligibility-questionnaire-summary.component.html',
  styleUrls: [
    './loan-eligibility-questionnaire-summary.component.css',
    '../page-shared.css',
  ],
})
export class LoanEligibilityQuestionnaireSummaryComponent implements OnInit {
  loading: boolean = true;
  occupationStatusLabel: string;
  navigationInProgress: boolean = false;

  existingLeq: LeqInfoDto;
  selectedMethodLeqType: LeqType;
  LeqType: typeof LeqType = LeqType;

  constructor(
    private store: Store,
    private router: Router,
    private leqService: LeqService,
    private loggingService: LoggingService,
    private queryParamsService: QueryParamsService,
    private customerJourneyService: CustomerJourneyService
  ) {}

  async ngOnInit(): Promise<void> {
    this.selectedMethodLeqType = this.leqService.getSelectedMethodLeqType(
      this.queryParamsService.getQueryParams().method,
      this.store.snapshot().paymentRequest.request
    );

    try {
      this.existingLeq = await this.leqService.fetchLeq();
      if (
        this.existingLeq.status === KalpStatus.PENDING ||
        this.isLeqIncomplete()
      ) {
        this.navigateToLeqForm();
        return;
      }

      this.occupationStatusLabel = this.mapEmploymentToReadable(
        this.existingLeq.employment
      );
      this.loading = false;
    } catch (err) {
      this.loggingService.log(err);
      this.router.navigate([routeNames.ERROR], {
        queryParamsHandling: 'merge',
      });
    }
  }

  continueToNextStepInJourney(): void {
    this.navigationInProgress = true;
    this.customerJourneyService.getNextRoute(true).subscribe((route) => {
      this.router
        .navigate([route], { queryParamsHandling: 'preserve' })
        .then(() => {
          this.navigationInProgress = false;
        });
    });
  }

  navigateToLeqForm(): void {
    this.navigationInProgress = true;
    this.router
      .navigate([routeNames.LEQ], { queryParamsHandling: 'preserve' })
      .then(() => {
        this.navigationInProgress = false;
      });
  }

  reroute(): void {
    this.router.navigate([routeNames.EMAIL_AND_INVOICE], {
      queryParamsHandling: 'merge',
    });
  }

  mapEmploymentToReadable(employment: Employment): string {
    switch (employment) {
      case Employment.PERMANENT:
        return 'Fastanställd';
      case Employment.PART_TIME:
        return 'Timanställd';
      case Employment.RETIRED:
        return 'Pensionär';
      case Employment.STUDENT:
        return 'Studerande';
      case Employment.UNEMPLOYED:
        return 'Arbetslös';
      case Employment.ENTREPRENEUR:
        return 'Egenföretagare';
      default:
        return 'UNKNOWN EMPLOYMENT TYPE';
    }
  }

  isLeqIncomplete(): boolean {
    const hasLeqMissingValues: boolean = Object.values(this.existingLeq).some(
      (value) => value === null
    );

    return (
      hasLeqMissingValues && this.selectedMethodLeqType === LeqType.STANDARD
    );
  }

  getNumberOfChildren(): string {
    if (this.existingLeq.numberOfChildren >= 5) {
      return '5 eller fler';
    }

    return `${this.existingLeq.numberOfChildren} st`;
  }
}
